import React, { useState, useEffect } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import ApprovedListModal from "../components/prApprovedModal";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link, useParams } from "react-router-dom";

const ApprovedPrList = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedPrNo, setSelectedPrNo] = useState(null);
   const canView  = hasPermission("Pending Purchase List", "view");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/pr_approvedDetailList");
      setData(response.data.BOlist);
      setFilteredData(response.data.BOlist);
    } catch (error) {
      console.error("Error fetching BOlist:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
      setFilteredData(data);
      return;
    }

    const filtered = data.filter((item) =>
      String(item.pnumber || "").toLowerCase().includes(term) ||
      String(item.fld_branchcode || "").toLowerCase().includes(term)
    );

    setFilteredData(filtered);
  };

   if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  // Pagination logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const openModal = (prNo) => {
    setSelectedPrNo(prNo);
    setShowModal(true);
  };

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Pending Purchase Requisition-List</h2>
          <Time />
        </section>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Req No"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Req No</th>
                <th>Date</th>
                <th>Branch</th>
                <th>Department</th>
                <th>Due Date</th>
                <th>Purpose</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td onClick={() => openModal(item.pnumber)} style={{ cursor: "pointer", color: "blue" }}>
                      {item.pnumber}
                    </td>
                    <td>{new Date(item.fld_now).toLocaleDateString()}</td>
                    <td>{item.fld_branchcode}</td>
                    <td>{item.fld_dept}</td>
                    <td>{new Date(item.fld_duedate).toLocaleDateString()}</td>
                    <td>{item.fld_purpose}</td>
                    <td>{item.fld_remarks}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {[...Array(Math.max(0, Math.min(3, totalPages - 1)))].map((_, index) => {
            const pageNumber = currentPage + index;
            if (pageNumber > 1 && pageNumber <= totalPages) {
              return (
                <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                  {pageNumber}
                </button>
              );
            }
            return null;
          })}

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
            Next
          </button>
        </div>
      </div>

      {/* Modal - Placed outside table to prevent hydration error */}
      {showModal && <ApprovedListModal showModal={showModal} closeModal={() => setShowModal(false)} prNo={selectedPrNo} />}
    </div>
  );
};

export default ApprovedPrList;
